module.exports = __webpack_public_path__ + "static/media/green_door.39a94650.webp";